import { render, staticRenderFns } from "./EquipmentRow.vue?vue&type=template&id=488005dc&scoped=true"
import script from "./EquipmentRow.vue?vue&type=script&lang=js"
export * from "./EquipmentRow.vue?vue&type=script&lang=js"
import style0 from "./EquipmentRow.vue?vue&type=style&index=0&id=488005dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488005dc",
  null
  
)

export default component.exports